import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../../../service/auth/user.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(
        private userSvc: UserService,
        private router: Router) {

    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const credential = this.userSvc.getUser();
        if (credential != null) {
            if (credential.resetSenha == 'true') {
                this.router.navigate(['auth/change-password']);
                return false;
            }
            else if (credential.id_estabelecimento == null){ 
                this.router.navigate(['pages/auth/estabelecimento']);
                return false; 
            } 
            else {
                return true;
            }
        }
        else {
            this.router.navigate(['pages/auth/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }

    }
}
